export const mtrPermitStatus = {
  A: 'Approved',
  R: 'Referred',
  D: 'Declined'
}

export const mtrOccupation = {
  I: 'Indoor',
  O: 'Outdoor'
}

export const mtrStatusField = {
  NOCLM: 'NOCLM',
  CLMAMT: 'CLMAMT',
  ISDRV: 'ISDRV',
  DRVAGE: 'DRVAGE',
  DRVEXP: 'DRVEXP',
  VEHREGYR: 'VEHREGYR'
}

export const mtrStatusFieldDesc = {
  NOCLM: 'No Claim',
  CLMAMT: 'Claim Amount',
  ISDRV: 'Is Driver',
  DRVAGE: 'Driver Age',
  DRVEXP: 'Driver Experience',
  VEHREGYR: 'Vehicle Registration Year'
}

export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
  // CT: 'Credit Terms',
  // MCC: 'Manual Credit Card'
}

export const paymentInstalmentPlan = {
  1: '1',
  6: '6',
  12: '12'
}

export const mtrGapCalcMethod = {
  S: 'Standard Risk Factor',
  L: 'NAP Subtotal Level',
  C: 'Motor Points Tariff (Additive Model)',
  M: 'Motor Points Tariff (Multiplicative)',
  N: 'Motor No Claim Discount',
  E: 'Manual Entry'
}

export const statsUse = {
  1: 'Policy Risk',
  2: 'Policy Item',
  5: 'Claim Header',
  6: 'Claimant',
  7: 'Claim Item'
}
